import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"
import { type LucideIcon } from "lucide-react"

type StatCardProps = {
    count: string | number
    text: string
    icon: LucideIcon
}

const StatCard = ({ count, text, icon: Icon }: StatCardProps) => (
    <Card className="h-full gap-1  p-4 lg:w-fit min-w-[12rem] bg-primary-bg border-zinc-200 shadow-none">
        <CardContent className="flex flex-row items-start justify-between gap-2 p-0 ">
            <div className="text-[#521B66] font-semibold text-4xl">{count}</div>
            <Icon className="h-5 w-5 shrink-0 text-zinc-500" />
        </CardContent>
        <CardHeader className="flex flex-row items-start justify-between gap-2 p-0 contain">
            <CardTitle className="text-4 text-zinc-500">{text}</CardTitle>
        </CardHeader>
    </Card>
)

export default StatCard
